// eslint-disable-next-line
import store from '../store';
const currentDispatchers = [];
export default {
  async singleDispatcher(dispatchername) {
    currentDispatchers.push(dispatchername);
    console.log({ currentDispatchers });
    store.subscribe(async (mutation) => {
      if (mutation.type === 'SET_CURRENT_ENTITY' && store.state.current_selected_entity) {
        const { word, type, qid } = store.state.current_selected_entity;
        console.log({
          dispatchername, word, type, qid,
        });
        if (dispatchername === 'twitterDetails') {
          const wordObj = { topic: word, count: 10 };
          await store.dispatch(dispatchername, wordObj);
        } else if (dispatchername === 'wikiGraphAction') {
          const wordObj = {
            word, type: 'string', lang: 'en', graph_type: 'force',
          };
          await store.dispatch(dispatchername, wordObj);
        } else if (dispatchername === 'dendroGraphAction') {
          const wordObj2 = {
            word, type: 'string', lang: 'en', graph_type: 'dendro',
          };
          await store.dispatch(dispatchername, wordObj2);
        } else if (dispatchername === 'wikiSnippet') {
          if (type === 'entity' && qid) {
            await store.dispatch(dispatchername, { qid, type: 'entity' });
          } else {
            const wordObj = { word, type: 'word' };
            await store.dispatch(dispatchername, wordObj);
          }
        } else {
          await store.dispatch(dispatchername, word);
        }
      }
    });
  },

  async excludeDispatcher(searchWord, excludeDispatchername) {
    const wikiSnippetObj = { word: searchWord, type: 'word' };
    const twitterObj = { topic: searchWord, count: 10 };
    const wikiGraphActionObj = {
      word: searchWord, type: 'string', lang: 'en', graph_type: 'force',
    };
    const dendroGraphActionObj = {
      word: searchWord, type: 'string', lang: 'en', graph_type: 'dendro',
    };
    if (!excludeDispatchername.includes('wikiWordFetch')) {
      store.dispatch('wikiWordFetch', searchWord);
    } if (!excludeDispatchername.includes('wikiSnippet')) {
      store.dispatch('wikiSnippet', wikiSnippetObj);
    } if (!excludeDispatchername.includes('twitterDetails')) {
      store.dispatch('twitterDetails', twitterObj);
    } if (!excludeDispatchername.includes('wikiGraphAction')) {
      store.dispatch('wikiGraphAction', wikiGraphActionObj);
    } if (!excludeDispatchername.includes('dendroGraphAction')) {
      store.dispatch('dendroGraphAction', dendroGraphActionObj);
    } if (!excludeDispatchername.includes('fetchExploreInformation')) {
      store.dispatch('fetchExploreInformation', searchWord);
    } if (!excludeDispatchername.includes('fetchThreeDModel')) {
      store.dispatch('fetchThreeDModel', searchWord);
    } if (!excludeDispatchername.includes('gmodule/exploreGraphFetch')) {
      store.dispatch('gmodule/exploreGraphFetch', searchWord);
    } if (!excludeDispatchername.includes('fetchExploreDescription')) {
      store.dispatch('fetchExploreDescription', searchWord);
    }
  },
};
